const ApplicationEnum = {
  ALUGUEL: 1,
  ALMOXARIFADO: 2,
  MANUTENÇÃO: 3,
  FATURAMENTO: 4,
}

export default ApplicationEnum
